export const roleDialogFeatureEn = {
  Dashboard: "Allow the user to access and view the dashboard.",
  Analytics: "Allow the user to access and configure analytics dashboards.",
  CatalogManagement: "Allow the user to manage catalog items.",
  Customers:
    "Allow user to view and manage customer profiles and create customer portal accounts so customers can directly upload purchase orders to the Dost Portal.",
  DeveloperSettings:
    "Allow the user to access and modify developer and API settings.",
  DiscrepancyConfigurations:
    "Allow the user to set and update discrepancy rules.",
  DocumentConfigurations:
    "Allow the user to configure document fields, formats, and rules.",
  Documents: "Allow the user to view and manage documents.",
  ExportConfigurations: "Allow the user to set up and manage export rules.",
  ExportTemplates: "Allow the user to create and maintain export templates.",
  Integrations: "Allow the user to set up and manage integrations.",
  ManualDocumentsDN:
    "Allow the user to create and manage manual delivery notes.",
  ManualDocumentsIN: "Allow the user to create and manage manual invoices.",
  ManualDocumentsPO:
    "Allow the user to create and manage manual purchase orders.",
  MappingConfigurations:
    "Allow the user to configure and update mapping rules.",
  Payments: "Allow the user to view and manage payment records.",
  Report: "Allow the user to access and add reports.",
  RoleManagement: "Allow the user to create and manage user roles.",
  SelfTraining: "Allow the user to train the AI using custom documents.",
  Suppliers:
    "Allow the user to view and manage supplier profiles and create supplier portal accounts so suppliers can directly upload invoices to the Dost Portal.",
  UserManagement: "Allow the user to add and manage Dost Portal users.",
  WorkflowApproval: "Allow the user to approve/reject the documents.",
  WorkflowManagement:
    "Allow the user to configure approval settings so documents are sent to the right person when specific conditions are met.",
  NotificationApp:
    "Allow the user to approve or reject documents directly from Slack with reasons.",
  Employee: `Allow the user to manage employees`,
  Expenses: `Allow the user to manage expenses`,
  ExpenseCategory: `Allow the user to add expense category`,
  InvoicePayments: `Allow the user to manage invoice payments`,
  PaymentSchedule: `Allow the user to manage payment schedules`,
  Items: `Allow the user to manage items`,
  Taxes: `Allow the user to manage taxes`,
  DocumentCustomView: `Allow the user to create and manage custom document views with personalized filters and columns.`,
};
